import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "units";

export const dynamic = "force-dynamic";

export class UnitService {
  // Token handled by cookie

  // add a new unit
  async addUnit(unit) {
    try {
      const response = await axios.post(`${apiUrl}`, unit, {
        withCredentials: true
      });
      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get all units
  async getUnits() {
    try {
      const res = await axios.get(`${apiUrl}`, {
        withCredentials: true
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  // get a single unit
  async getUnit(id) {
    try {
      const res = await axios.get(`${apiUrl}/${id}`, {
        withCredentials: true
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  // update a unit
  async updateUnit(unit) {
    try {
      const response = await axios.put(`${apiUrl}/${unit.id}`, unit, {
        withCredentials: true
      });
      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // delete a unit
  async deleteUnit(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        withCredentials: true
      });
      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}
